import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import {
  ApolloFilterFields,
  APOLLO_DEFAULT_FILTERS,
} from "@/shared/utils/contactConfig";
import Accordion from "@/shared/components/Accordion";
import React from "react";

function appliedFiltersHasValues(appliedFilters) {
  return Object.entries(appliedFilters || {}).some(([, v]) => {
    if (v == null) return false;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === "boolean") return v;
    if (typeof v === "object") {
      if (Array.isArray(v.values)) return v.values.length > 0;
      if ("value" in v && v.value != null) return true;
      return Object.keys(v).length > 0;
    }
    return !!v;
  });
}

const ApolloFilters = ({
  appliedFilters,
  clearFilters,
  onUpdate,
  filters,
  setFilters,
  filterFields = ApolloFilterFields,
  defaultFiltersSnapshot = APOLLO_DEFAULT_FILTERS,
  queryEcho,
  applySubmitDisabled,
  applyBusy = false,
  /** When set, a Close button is pinned to the bottom of the panel. */
  onClose,
}) => {
  const hasApplied = appliedFiltersHasValues(appliedFilters);
  const echoTrim = typeof queryEcho === "string" ? queryEcho.trim() : "";
  const showEchoBanner = echoTrim.length > 0;

  const hasChanges =
    JSON.stringify(filters) !== JSON.stringify(defaultFiltersSnapshot);

  const applyDisabledExplicit =
    typeof applySubmitDisabled === "boolean"
      ? applySubmitDisabled || applyBusy
      : !hasChanges || applyBusy;

  /** Show clear when API-applied filters or any value updated */
  const showClearFilters = hasApplied || showEchoBanner || hasChanges;

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex items-center justify-between gap-1 border-b border-gray-200 dark:border-gray-800 p-3">
        <h6 className="text-sm font-semibold text-gray-800 dark:text-gray-100">Filters</h6>
        <div className="flex gap-2">
          {showClearFilters && (
            <SecondaryButton
              title="Clear Filters"
              textColor="light"
              onClick={clearFilters}
              className="shadow-none text-error-500 border-error-500"
            />
          )}
          <SecondaryButton
            title="Apply"
            textColor="light"
            onClick={onUpdate}
            disabled={applyDisabledExplicit}
            isLoading={applyBusy}
            className="shadow-none"
          />
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto">
        <Accordion
          filterFields={filterFields}
          filters={filters}
          setFilters={setFilters}
          appliedFilters={appliedFilters}
          defaultFiltersSnapshot={defaultFiltersSnapshot}
        />
      </div>

      {onClose && (
        <div className="shrink-0 border-t border-gray-200 dark:border-gray-800 p-3">
          <SecondaryButton
            title="Close"
            aria-label="Close filters"
            onClick={onClose}
            className="w-full justify-center shadow-none"
          />
        </div>
      )}
    </div>
  );
};

export default ApolloFilters;
